var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"poi-popup",class:_vm.css,style:(_vm.style),on:{"click":function($event){return _vm.$f7router.navigate('/poi/' + _vm.poi._id)}}},[_c('h2',{staticClass:"poi-popup-title"},[_vm._v(_vm._s(_vm.poi.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }